/**
 * Client-side CSV export with UTF-8 BOM (Excel-safe for Chinese).
 */
export function exportCsv(
  filename: string,
  headersOrTable: string[] | (string | number | null | undefined)[][],
  rows?: (string | number | null | undefined)[][]
): void {
  // 兼容兩種呼叫：exportCsv(name, headers, rows) 與 exportCsv(name, [headerRow, ...rows])
  let headers: string[];
  if (rows === undefined) {
    const table = headersOrTable as (string | number | null | undefined)[][];
    headers = (table[0] || []).map(String);
    rows = table.slice(1);
  } else {
    headers = headersOrTable as string[];
  }
  const escape = (v: string | number | null | undefined): string => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [headers.map(escape).join(','), ...rows.map((r) => r.map(escape).join(','))];
  const blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
